// 开发环境配置项
module.exports = {
    jsonPath: '/',
};